<template>
  <div>
    <div class="ui fluid segment">
      <div class="ui dividing header">
        <h4>
          Patient Information
        </h4>
      </div>
      <abstractTable
        :data="patientInfo"
        :definitionTable="true"
        :definitionTableWidth="'16%'"
        :classes="'ui compact definition table'"
      >
      </abstractTable>

      <!-- <div class="ui dividing header">
        <h4>
          Doctor Information
        </h4>
      </div> -->
      <!-- <abstractTable
        :data="doctorInfo"
        :definitionTable="true"
        :definitionTableWidth="'16%'"
        :classes="'ui compact definition table'"
      > -->
      <!-- </abstractTable> -->

      <div class="ui dividing header">
        <h4>
          Packages Information
        </h4>
      </div>
      <abstractTable
        :columns="packagesColumns"
        :data="computedPackages"
        :hasFooter="true"
        :classes="'ui very compact left aligned celled center aligned table'"
      >
        <template slot="footer">
          <th :colspan="isAdmin() ? 5 : 4"></th>
          <th style="font-weight: bold;">
            {{ formatPrice(reservationTotalPrice) }}
          </th>
        </template>
      </abstractTable>

      <div class="ui dividing header" v-if="!isUpdate && !visitsSkipped">
        <h4>
          Visits Information
        </h4>
      </div>
      <div class="ui three column grid" v-if="!isUpdate && !visitsSkipped">
        <div class="column" v-for="visit in reservationVisits" :key="visit.id">
          <showVisit class="ui green segment" :visit="visit" />
        </div>
      </div>
    </div>
    <div class="ui clearing red segment">
      <table class="ui celled center aligned table">
        <thead>
          <tr>
            <th>Package</th>
            <th width="10%">Online</th>
            <th width="20%">Amount</th>
            <th width="40%">Description</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(transaction, index) in transactions" :key="index">
            <td>
              <select
                class="ui fluid search dropdown package-search"
                name="doctor"
                v-model="transaction.package_id"
              >
                <option value="">Choose Package</option>
                <option :value="p.id" v-for="p in reservationPackages" :key="p.id">
                  {{ p.name }}
                </option>
              </select>
            </td>
            <td>
              <div class="ui toggle checkbox">
                <input type="checkbox" v-model="transaction.online"/>
                <label></label>
              </div>
            </td>
            <td>
              <div class="ui fluid input">
                <input type="number" v-model="transaction.amount">
              </div>
            </td>
            <td>
              <div class="ui fluid input">
                <input type="text" v-model="transaction.description">
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="ui red segment">
      <div class="ui form">
        <div class="field">
          <label for="note">Note</label>
          <textarea
            name=""
            id=""
            rows="4"
            placeholder="Note"
            v-model="note"
          />
        </div>
      </div>
    </div>

    <div style="margin-bottom: 30px;">
      <div
        class="ui blue left labeled icon button"
        style="background-color: #092442"
        @click="previous()"
      >
        <i class="left arrow icon"></i>
        previous
      </div>

      <div
        class="ui blue right floated right labeled icon button"
        style="background-color: #092442"
        @click="next()"
      >
        <i class="right arrow icon"></i>
        Save
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable')
      .default,
    showVisit: require('@/components/steps/reservations/new_reservations_steps/packages-visits-components//ShowVisit')
      .default
  },
  props: {
    patient: { type: Object, required: true },
    doctor: { type: Object, required: true },
    reservationPackages: { type: Array, required: true },
    reservationVisits: { type: Array, required: true },
    visitsSkipped: { type: Boolean, default: false }
  },
  data() {
    return {
      discount: 0,
      note: '',
      transactions: [{
        package_id: null,
        online: false,
        amount: null,
        description: null
      }]
    };
  },
  mounted () {
    this.$nextTick(() => {
      $('.package-search').dropdown()
    });
  },
  watch: {
    transactions: {
      handler: function () {
        let completedTransactions = this.transactions.filter((transaction, index) => {
          return transaction.package_id && transaction.amount > 0
        })

        let isLastTransactionCompleted = false
        if (this.transactions.length > 0) {
          let lastTransaction = this.transactions[this.transactions.length - 1]
          isLastTransactionCompleted = !!lastTransaction.package_id && lastTransaction.amount > 0
        }

        if (isLastTransactionCompleted) {
          completedTransactions.push({
            package_id: null,
            online: false,
            amount: null,
            description: null
          })

          this.transactions = completedTransactions
        }

        this.$nextTick(() => {
          $('.package-search').dropdown()
        })
      },
      deep: true
    }
  },
  computed: {
    isUpdate () {
      return this.$route.name === 'Update_Reservation'
    },
    patientInfo() {
      return {
        [this.$t('name')]: this.adjustName(this.patient.name),
        [this.$t('mobile')]: this.patient.cell_phone,
        [this.$t('weight')]: this.patient.weight,
        [this.$t('gender')]: this.getGender(this.patient.gender)
      };
    },
    // doctorInfo() {
    //   return {
    //     name: this.doctor.user.name
    //   };
    // },
    packagesColumns() {
      return [
        { header: 'Name', fieldName: 'name', show: true, width: '15%' },
        { header: 'Description', fieldName: 'description', show: true },
        { header: 'Unit Price', fieldName: 'unit_price', show: this.isAdmin() },
        { header: 'Quantity', fieldName: 'quantity', show: true },
        { header: 'Number Of Repeat', fieldName: 'repeated', show: true },
        { header: 'Total Price', fieldName: 'totalPrice', show: true }
      ];
    },
    reservationTotalPrice() {
      return window._.sumBy(this.reservationPackages, selectedPackage => {
        return (
          Number(selectedPackage.unit_price) *
          Number(selectedPackage.quantity) *
          Number(selectedPackage.units)
        );
      });
    },
    computedPackages() {
      let formlatedPackages = [];

      window._.each(this.reservationPackages, selectedPackage => {
        let totalPrice =
          Number(selectedPackage.unit_price) *
          Number(selectedPackage.quantity) *
          Number(selectedPackage.units);

        formlatedPackages.push({
          name: this.getPackageName(selectedPackage),
          description: selectedPackage.description,
          unit_price: this.isAdmin() ? this.formatPrice(selectedPackage.unit_price, 2) : undefined,
          quantity: selectedPackage.units,
          repeated: selectedPackage.quantity,
          totalPrice: this.formatPrice(totalPrice, 2)
        });
      });

      return formlatedPackages;
    }
  },
  methods: {
    formatReservationVisits () {
      this.reservationVisits = this.reservationVisits.map(rv => ({
        ...rv, 
        packages: this.getVisitPackages(rv.packages)
      }))
    },
    getVisitPackages (visit) {
      return visit.packages.map(p => ({...p, name: this.reservationPackages.find(rp => rp === p.id).name}))
    },
    getPackageName(selectedPackage) {
      let quantity = selectedPackage.units ? selectedPackage.units : selectedPackage.quantity
      let packageName = selectedPackage.name + ' :: ' + selectedPackage.unit_price + ' × ' 
        + quantity

      if (selectedPackage.entities && selectedPackage.entities[0]) {
        packageName = selectedPackage.entities[0].name + ' :: ' + packageName
      }

      return packageName
    },
    previous() {
      this.$emit('reservation-goBack');
    },
    next() {
      this.$emit('reservation-reviewConfirmed', {
        data: {
          note: this.note,
          transactions: this.transactions
        }
      });
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/steps/reservations/new_reservations_steps/ReviewStep.vue